import { getCurrentDubaiDate } from "../../agent/date/getCurrentDubaiDate"

export function getStatusBroadcast (date: string): string {
    const now = new Date(getCurrentDubaiDate())
    const hideDate = new Date(date)
    return now < hideDate ? 'Active' : 'Completed'
}
